import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  COLUMN_MAPPING,
  CORRECT_STRING_VALUE,
  INCORRECT_STRING_VALUE,
  PARTIAL_STRING_VALUE,
  RESULT_COLUMN,
  ResultFragmentProps,
} from './models';
import {
  faCheckSquare,
  faWindowClose,
} from '@fortawesome/free-solid-svg-icons';

export function ResultFragment({
  colIndex: index,
  result,
}: ResultFragmentProps): JSX.Element {
  if (COLUMN_MAPPING[index] === RESULT_COLUMN) {
    if (result === CORRECT_STRING_VALUE) {
      return (
        <FontAwesomeIcon icon={faCheckSquare} className="fa-check-correct" />
      );
    } else if (result === INCORRECT_STRING_VALUE) {
      return (
        <FontAwesomeIcon icon={faWindowClose} className="fa-check-incorrect" />
      );
    } else if (result === PARTIAL_STRING_VALUE) {
      return (
        <span className="fa-check-partial" >&mdash;</span>
      );
    }
  }
  return <>{result}</>;
}
